<div class="date-selector__wrapper">
    <div class="date-selector__col-prev" *ngIf="showMobileArrows">
        <button
            class="date-selector__btn btn btn--big btn--primary btn--maximal"
            (click)="onDayArrowClick('back')"
            (keydown.enter)="onDayArrowClick('back')"
            (keydown.space)="onDayArrowClick('back')"
            [disabled]="mobileBackArrowDisabled"
            type="button"
        >
            <span class="icon icon-arrow-left"></span>
        </button>
    </div>

    <div class="date-selector__col-input" [ngClass]="{ 'full-width': !showMobileArrows }">
        <label class="date-selector__input-label" *ngIf="label">{{ label | translate }}</label>
        <input
            [ngClass]="{ 'removePadding': !label, 'date-selector__input--material-icon': useMaterialIcon }"
            type="button"
            attr.aria-label="{{ ariaLabel | translate }} {{ toHumanReadableDate(selectedDate) }}"
            [disabled]="disabled"
            value="{{ selectedDate | date: dateFormat }}"
            (click)="showCalendar()"
            class="date-selector__input"
            (keydown.enter)="showCalendar($event)"
            (keydown.space)="showCalendar($event)"
            #dateSelectorInput
            tabindex="{{ isOpened ? -1 : 0 }}"
        />
        <mat-icon
            class="date-selector__icon"
            [ngClass]="{ 'date-selector__icon--disabled': disabled }"
            *ngIf="useMaterialIcon"
            >date_range</mat-icon
        >
    </div>

    <div class="date-selector__col-next" *ngIf="showMobileArrows">
        <button
            class="date-selector__btn btn btn--big btn--primary btn--maximal"
            (click)="onDayArrowClick('forward')"
            [disabled]="mobileForwardArrowDisabled"
            type="button"
        >
            <span class="icon icon-arrow-right"></span>
        </button>
    </div>

    <div
        role="dialog"
        class="date-picker"
        [ngClass]="{ opened: isOpened }"
        attr.aria-expanded="{{ isOpened }}"
        attr.aria-label="{{ 'DATE_PICKER_CALENDAR_LABEL' | translate }}"
    >
        <div role="application">
            <ridango-calendar-controls
                [date]="date"
                [lang]="lang"
                [yearsControl]="yearsControl"
                [monthsControl]="monthsControl"
                (onDateChange)="dateChanged($event, true)"
                (onKeyDown)="handleControlsKeyDown($event)"
            >
            </ridango-calendar-controls>
            <div class="calendar">
                <div class="calendar-header">
                    <span *ngFor="let dayname of dayNames; let last = last" [ngClass]="{ last: last }">
                        {{ dayname | translate }}
                    </span>
                </div>

                <div class="block-week">
                    <div class="week" *ngFor="let week of weeks">
                        <ridango-calendar-day
                            *ngFor="let day of week; let last = last"
                            [item]="day"
                            [selected]="isSelected(day)"
                            [disabled]="day.disabled"
                            [last]="last"
                            [fullDate]="toHumanReadableDate(day.full_date)"
                            [current]="day.full_date?.getTime() === currentDate.getTime()"
                            (onItemSelected)="select($event)"
                            (onKeyDown)="moveToNextDate($event)"
                            [tabindex]="day.full_date?.getTime() === currentDate.getTime() ? 0 : -1"
                            role="presentation"
                        >
                        </ridango-calendar-day>
                    </div>
                </div>
            </div>
        </div>
        <div class="wcag-hidden" role="alert">{{ screenReaderCurrentMonth }}</div>
    </div>
</div>
